export const test_url_aws   = "https://housingapi.dev.nidhi.apcfss.in/ofmsapi/OfmsLogin";
export const live_url       = 'https://api.apshclfms.apcfss.in/ofmsapi/OfmsLogin'
// export const system_url     = 'http://192.168.1.155:8082/ofmsapi/OfmsLogin'
export const LOGIN_API_URL  = live_url;  
